module.exports = __webpack_public_path__ + "img/Dichtung.edb64533.jpg";